// import { useState, useEffect } from "react";
// import { LayoutDashboard, Building2, Users, Key, ScrollText, Settings } from "lucide-react";
// import DashboardLayout from "../../components/DashboardLayout";
// import { useNavigate } from "react-router-dom";
// import { supabase } from "../../lib/supabaseClient";

// const NAV = [
//   { label: "Dashboard",     icon: LayoutDashboard, path: "/admin/dashboard" },
//   { label: "Properties",    icon: Building2,        path: "/admin/properties" },
//   { label: "Users",         icon: Users,            path: "/admin/users" },
//   { label: "Valet Codes",   icon: Key,              path: "/admin/valet-codes" },
//   { label: "Activity Logs", icon: ScrollText,       path: "/admin/logs" },
//   { label: "Settings",      icon: Settings,         path: "/admin/settings" },
// ];

// function getToday() {
//   return new Date().toISOString().split("T")[0];
// }

// // ─── Stat Card ────────────────────────────────────────────────────────────────
// function StatCard({ label, value, sub, color = "var(--g600)", delay, onClick }) {
//   return (
//     <div
//       className={`fu ${delay}`}
//       onClick={onClick}
//       style={{
//         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
//         padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,.04)",
//         cursor: onClick ? "pointer" : "default",
//         transition: "box-shadow .15s",
//       }}
//       onMouseEnter={e => onClick && (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,.08)")}
//       onMouseLeave={e => onClick && (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,.04)")}
//     >
//       <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 10 }}>
//         {label}
//       </div>
//       <div style={{ fontSize: 30, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
//         {value ?? "—"}
//       </div>
//       {sub && <div style={{ fontSize: 12, color: "var(--mut)", marginTop: 6 }}>{sub}</div>}
//     </div>
//   );
// }

// // ─── Quick Action Card ────────────────────────────────────────────────────────
// function QuickCard({ title, desc, btnLabel, onClick, delay }) {
//   return (
//     <div className={`fu ${delay}`} style={{
//       background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
//       padding: "20px", display: "flex", flexDirection: "column", gap: 10,
//     }}>
//       <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
//       <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, flex: 1 }}>{desc}</div>
//       <button onClick={onClick} style={{
//         alignSelf: "flex-start", padding: "7px 16px", borderRadius: 8,
//         border: "1.5px solid var(--g300)", background: "var(--g50)",
//         color: "var(--g600)", fontSize: 12, fontWeight: 700, cursor: "pointer",
//       }}>
//         {btnLabel}
//       </button>
//     </div>
//   );
// }

// // ─── Main Dashboard ───────────────────────────────────────────────────────────
// export default function SuperAdminDashboard() {
//   const navigate = useNavigate();
//   const today    = getToday();

//   const [stats,    setStats]    = useState(null);
//   const [loading,  setLoading]  = useState(true);
//   const [recentLogs, setRecentLogs] = useState([]);

//   useEffect(() => {
//     const fetchStats = async () => {
//       setLoading(true);

//       const [
//         { count: totalProps },
//         { count: activeProps },
//         { count: totalUsers },
//         { count: activeUsers },
//         { count: activeValets },
//         { count: todayActivity },
//         { data: logs },
//       ] = await Promise.all([
//         supabase.from("properties").select("*", { count: "exact", head: true }),
//         supabase.from("properties").select("*", { count: "exact", head: true }).eq("is_active", true),
//         supabase.from("profiles").select("*", { count: "exact", head: true }),
//         supabase.from("profiles").select("*", { count: "exact", head: true }).eq("is_active", true),
//         supabase.from("valet_codes").select("*", { count: "exact", head: true }).eq("is_active", true),
//         supabase.from("activity_logs").select("*", { count: "exact", head: true })
//           .gte("created_at", `${today}T00:00:00`)
//           .lte("created_at", `${today}T23:59:59`),
//         supabase.from("activity_logs")
//           .select("id, action, property_id, created_at, metadata")
//           .order("created_at", { ascending: false })
//           .limit(5),
//       ]);

//       setStats({ totalProps, activeProps, totalUsers, activeUsers, activeValets, todayActivity });
//       setRecentLogs(logs || []);
//       setLoading(false);
//     };

//     fetchStats();
//   }, [today]);

//   function formatAction(action) {
//     switch (action) {
//       case "valet_status_changed":      return "Valet status updated";
//       case "resident_trash_submitted":  return "Resident trash submitted";
//       default: return action?.replace(/_/g, " ") || "—";
//     }
//   }

//   function formatTime(iso) {
//     return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//   }

//   return (
//     <DashboardLayout role="super_admin" title="System Overview" navItems={NAV}>

//       {/* Header */}
//       <div className="fu" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#6a1b9a", marginBottom: 6 }}>Super Admin</div>
//         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 6 }}>
//           Welcome back.
//         </h2>
//         <p style={{ fontSize: 13, color: "var(--mut)" }}>
//           Full system control — all properties under one view.
//         </p>
//       </div>

//       {/* Stats Grid */}
//       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 14, marginBottom: 24 }}>
//         <StatCard
//           label="Total Properties"
//           value={loading ? "…" : stats?.totalProps ?? 0}
//           sub={`${stats?.activeProps ?? "—"} active`}
//           color="#6a1b9a" delay="d1"
//           onClick={() => navigate("/admin/properties")}
//         />
//         <StatCard
//           label="Total Users"
//           value={loading ? "…" : stats?.totalUsers ?? 0}
//           sub={`${stats?.activeUsers ?? "—"} active`}
//           color="var(--g600)" delay="d2"
//           onClick={() => navigate("/admin/users")}
//         />
//         <StatCard
//           label="Active Valets"
//           value={loading ? "…" : stats?.activeValets ?? 0}
//           sub="Valet codes active"
//           color="#e65100" delay="d3"
//           onClick={() => navigate("/admin/valet-codes")}
//         />
//         <StatCard
//           label="Today's Activity"
//           value={loading ? "…" : stats?.todayActivity ?? 0}
//           sub="Actions logged today"
//           color="#1565c0" delay="d4"
//           onClick={() => navigate("/admin/logs")}
//         />
//       </div>

//       {/* Recent Activity */}
//       <div className="fu d3" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//           Recent Activity
//         </div>
//         {loading ? (
//           <div style={{ textAlign: "center", padding: "24px 0", fontSize: 13, color: "var(--mut)" }}>Loading…</div>
//         ) : recentLogs.length === 0 ? (
//           <div style={{
//             textAlign: "center", padding: "24px",
//             background: "#fff", borderRadius: 12, border: "1.5px dashed var(--ln)",
//             fontSize: 13, color: "var(--mut)",
//           }}>No activity yet.</div>
//         ) : (
//           <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
//             {recentLogs.map(log => (
//               <div key={log.id} style={{
//                 display: "flex", alignItems: "center", gap: 12,
//                 padding: "12px 16px", borderRadius: 11,
//                 background: "#fff", border: "1px solid var(--ln)",
//                 boxShadow: "0 1px 3px rgba(0,0,0,.04)",
//               }}>
//                 <div style={{
//                   width: 8, height: 8, borderRadius: "50%", flexShrink: 0,
//                   background: log.action === "valet_status_changed" ? "#ff9800" : "var(--g600)",
//                 }} />
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
//                     {formatAction(log.action)}
//                   </div>
//                   {log.metadata?.status && (
//                     <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
//                       Status: {log.metadata.status.replace(/_/g, " ")}
//                     </div>
//                   )}
//                 </div>
//                 <div style={{ fontSize: 11.5, color: "var(--mut)", flexShrink: 0 }}>
//                   {formatTime(log.created_at)}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Quick Actions */}
//       <div className="fu d4">
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//           Quick Actions
//         </div>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
//           <QuickCard
//             title="Property Management"
//             desc="Create, edit, activate & deactivate properties. Generate codes."
//             btnLabel="Go to Properties →"
//             onClick={() => navigate("/admin/properties")}
//             delay="d1"
//           />
//           <QuickCard
//             title="User Management"
//             desc="View all users across properties. Activate or deactivate accounts."
//             btnLabel="Go to Users →"
//             onClick={() => navigate("/admin/users")}
//             delay="d2"
//           />
//           <QuickCard
//             title="Valet Codes"
//             desc="Create and deactivate valet access codes per property."
//             btnLabel="Go to Valet Codes →"
//             onClick={() => navigate("/admin/valet-codes")}
//             delay="d3"
//           />
//           <QuickCard
//             title="Activity Logs"
//             desc="All status changes and submissions with timestamps."
//             btnLabel="View Logs →"
//             onClick={() => navigate("/admin/logs")}
//             delay="d4"
//           />
//         </div>
//       </div>

//       <style>{`
//         @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
//       `}</style>
//     </DashboardLayout>
//   );
// }


import { useState, useEffect } from "react";
import { LayoutDashboard, Building2, Users, Key, ScrollText } from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";



function getToday() {
  return new Date().toISOString().split("T")[0];
}

// ─── Stat Card ────────────────────────────────────────────────────────────────
function StatCard({ label, value, sub, color = "var(--g600)", delay, onClick }) {
  return (
    <div
      className={`fu ${delay}`}
      onClick={onClick}
      style={{
        background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
        padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,.04)",
        cursor: onClick ? "pointer" : "default",
        transition: "box-shadow .15s",
      }}
      onMouseEnter={e => onClick && (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,.08)")}
      onMouseLeave={e => onClick && (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,.04)")}
    >
      <div style={{
        fontSize: 10, fontWeight: 700, letterSpacing: ".6px",
        textTransform: "uppercase", color: "var(--mut)", marginBottom: 10,
      }}>
        {label}
      </div>
      <div style={{
        fontSize: 30, fontWeight: 700, color,
        fontFamily: "'Outfit',sans-serif", lineHeight: 1,
      }}>
        {value ?? "—"}
      </div>
      {sub && (
        <div style={{ fontSize: 12, color: "var(--mut)", marginTop: 6 }}>{sub}</div>
      )}
    </div>
  );
}

// ─── Quick Action Card ────────────────────────────────────────────────────────
function QuickCard({ title, desc, btnLabel, onClick, delay }) {
  return (
    <div className={`fu ${delay}`} style={{
      background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
      padding: "20px", display: "flex", flexDirection: "column", gap: 10,
    }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
      <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, flex: 1 }}>{desc}</div>
      <button
        onClick={onClick}
        style={{
          alignSelf: "flex-start", padding: "7px 16px", borderRadius: 8,
          border: "1.5px solid var(--g300)", background: "var(--g50)",
          color: "var(--g600)", fontSize: 12, fontWeight: 700, cursor: "pointer",
        }}
      >
        {btnLabel}
      </button>
    </div>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const today    = getToday();

  // ── active: false everywhere — DashboardLayout ab khud URL se active derive karta hai
const NAV = [
  { label: "Dashboard",     icon: LayoutDashboard, path: "/admin/dashboard" },
  { label: "Properties",    icon: Building2,        path: "/admin/properties" },
  { label: "Users",         icon: Users,            path: "/admin/users" },
  { label: "Valet Codes",   icon: Key,              path: "/admin/valet-codes" },
  { label: "Activity Logs", icon: ScrollText,       path: "/admin/logs" },
  // { label: "Settings",      icon: Settings,         path: "/admin/settings" },
];

  const [stats,      setStats]      = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [recentLogs, setRecentLogs] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);

      const [
        { count: totalProps },
        { count: activeProps },
        { count: totalUsers },
        { count: activeUsers },
        { count: activeValets },
        { count: todayActivity },
        { data: logs },
      ] = await Promise.all([
        supabase.from("properties").select("*", { count: "exact", head: true }),
        supabase.from("properties").select("*", { count: "exact", head: true }).eq("is_active", true),
        supabase.from("profiles").select("*",   { count: "exact", head: true }),
        supabase.from("profiles").select("*",   { count: "exact", head: true }).eq("is_active", true),
        supabase.from("valet_codes").select("*", { count: "exact", head: true }).eq("is_active", true),
        supabase.from("activity_logs").select("*", { count: "exact", head: true })
          .gte("created_at", `${today}T00:00:00`)
          .lte("created_at", `${today}T23:59:59`),
        supabase.from("activity_logs")
          .select("id, action, property_id, created_at, metadata")
          .order("created_at", { ascending: false })
          .limit(5),
      ]);

      setStats({ totalProps, activeProps, totalUsers, activeUsers, activeValets, todayActivity });
      setRecentLogs(logs || []);
      setLoading(false);
    };

    fetchStats();
  }, [today]);

  function formatAction(action) {
    switch (action) {
      case "valet_status_changed":     return "Valet status updated";
      case "resident_trash_submitted": return "Resident trash submitted";
      default: return action?.replace(/_/g, " ") || "—";
    }
  }

  function formatTime(iso) {
    return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }

  return (
    <DashboardLayout role="super_admin" title="System Overview" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 24 }}>
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "2px",
          textTransform: "uppercase", color: "#6a1b9a", marginBottom: 6,
        }}>
          Super Admin
        </div>
        <h2 style={{
          fontFamily: "'Playfair Display',serif", fontSize: 24,
          fontWeight: 500, color: "var(--ink)", marginBottom: 6,
        }}>
          Welcome back.
        </h2>
        <p style={{ fontSize: 13, color: "var(--mut)" }}>
          Full system control — all properties under one view.
        </p>
      </div>

      {/* Stats Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: 14, marginBottom: 24,
      }}>
        <StatCard
          label="Total Properties"
          value={loading ? "…" : stats?.totalProps ?? 0}
          sub={`${stats?.activeProps ?? "—"} active`}
          color="#6a1b9a" delay="d1"
          onClick={() => navigate("/admin/properties")}
        />
        <StatCard
          label="Total Users"
          value={loading ? "…" : stats?.totalUsers ?? 0}
          sub={`${stats?.activeUsers ?? "—"} active`}
          color="var(--g600)" delay="d2"
          onClick={() => navigate("/admin/users")}
        />
        <StatCard
          label="Active Valets"
          value={loading ? "…" : stats?.activeValets ?? 0}
          sub="Valet codes active"
          color="#e65100" delay="d3"
          onClick={() => navigate("/admin/valet-codes")}
        />
        <StatCard
          label="Today's Activity"
          value={loading ? "…" : stats?.todayActivity ?? 0}
          sub="Actions logged today"
          color="#1565c0" delay="d4"
          onClick={() => navigate("/admin/logs")}
        />
      </div>

      {/* Recent Activity */}
      <div className="fu d3" style={{ marginBottom: 24 }}>
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "2px",
          textTransform: "uppercase", color: "var(--mut)", marginBottom: 12,
        }}>
          Recent Activity
        </div>
        {loading ? (
          <div style={{ textAlign: "center", padding: "24px 0", fontSize: 13, color: "var(--mut)" }}>
            Loading…
          </div>
        ) : recentLogs.length === 0 ? (
          <div style={{
            textAlign: "center", padding: "24px",
            background: "#fff", borderRadius: 12, border: "1.5px dashed var(--ln)",
            fontSize: 13, color: "var(--mut)",
          }}>
            No activity yet.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {recentLogs.map(log => (
              <div key={log.id} style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 16px", borderRadius: 11,
                background: "#fff", border: "1px solid var(--ln)",
                boxShadow: "0 1px 3px rgba(0,0,0,.04)",
              }}>
                <div style={{
                  width: 8, height: 8, borderRadius: "50%", flexShrink: 0,
                  background: log.action === "valet_status_changed" ? "#ff9800" : "var(--g600)",
                }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
                    {formatAction(log.action)}
                  </div>
                  {log.metadata?.status && (
                    <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
                      Status: {log.metadata.status.replace(/_/g, " ")}
                    </div>
                  )}
                </div>
                <div style={{ fontSize: 11.5, color: "var(--mut)", flexShrink: 0 }}>
                  {formatTime(log.created_at)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Quick Actions */}
      <div className="fu d4">
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "2px",
          textTransform: "uppercase", color: "var(--mut)", marginBottom: 12,
        }}>
          Quick Actions
        </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 12,
        }}>
          <QuickCard
            title="Property Management"
            desc="Create, edit, activate & deactivate properties. Generate codes."
            btnLabel="Go to Properties →"
            onClick={() => navigate("/admin/properties")}
            delay="d1"
          />
          <QuickCard
            title="User Management"
            desc="View all users across properties. Activate or deactivate accounts."
            btnLabel="Go to Users →"
            onClick={() => navigate("/admin/users")}
            delay="d2"
          />
          <QuickCard
            title="Valet Codes"
            desc="Create and deactivate valet access codes per property."
            btnLabel="Go to Valet Codes →"
            onClick={() => navigate("/admin/valet-codes")}
            delay="d3"
          />
          <QuickCard
            title="Activity Logs"
            desc="All status changes and submissions with timestamps."
            btnLabel="View Logs →"
            onClick={() => navigate("/admin/logs")}
            delay="d4"
          />
        </div>
      </div>
    </DashboardLayout>
  );
}